import { PageDataContainer, PageLink } from '../../../_start/layout/core';
import { formManagementSubmenu } from './FormManagementData';
import { FormManagementPage } from './FormManagementPage';

const breadcrumbs: Array<PageLink> = [
  {
    title: 'Home',
    path: '/',
    isActive: false,
  },
  {
    title: 'Form Management',
    path: '/form-management',
    isActive: false,
  },
];

export const FormManagementWrapper = () => {
  return (
    <>
      <PageDataContainer
        breadcrumbs={breadcrumbs}
        submenu={formManagementSubmenu}
      />
      <FormManagementPage />
    </>
  );
};
